import type { BlockDataType } from './BlockPeriodModel';
import type { BookingDataType } from './BookingPeriodModel';
import type { ConfigurationDataType } from './ConfigurationPeriodModel';
import type BasePeriodPartTemplate from '../templates/BasePeriodPartTemplate';

export type PeriodData = BlockDataType | BookingDataType | ConfigurationDataType;

export enum PeriodType {
    BOOKING = 'booking',
    BLOCK = 'block',
    CONFIGURATION = 'configuration'
}

export enum BlockDataTypeEnum {
    MANUAL_BLOCK = 'manual-block',
    SYNCED_BLOCK = 'synced-block'
}

export type PeriodDataApiType<DT = PeriodData> = {
    id: string;
    start: string;
    end: string;
    type?: string;
    data: DT;
};

export type PeriodDataType = {
    id: string;
    startDate: Date;
    endDate: Date;
};

export default abstract class AbstractPeriodModel {
    public id: string;

    public startDate: Date;

    public endDate: Date;

    public abstract readonly data: PeriodData;

    public abstract readonly type: PeriodType;

    abstract get template(): BasePeriodPartTemplate;

    protected constructor(id: string, start: Date, end: Date) {
        this.id = id;
        this.startDate = start;
        this.endDate = end;
    }
}
